import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Halls } from "@/components/Halls";
import { Organizations } from "@/components/Organizations";
import { Catering } from "@/components/Catering";
import { Heritage } from "@/components/Heritage";
import { Reservation } from "@/components/Reservation";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

export default function Home() {
  return (
    <div className="bg-[#121110] text-[#F5F5F0] min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Halls />
        <Organizations />
        <Catering />
        <Heritage />
        <Reservation />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
